<template>
    <div class="render-post render-post-pinterest" :class="scrollbarClass" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

        <div class="post-content">
       
            <div class="post-medias media" :class="{empty : notFile && !snippet.link}">
                <div class="media" v-for="media in medias.filter(m => ['image','video'].includes(m.type2) && m.type !== 'image/gif').slice(0,1)" :key="media.id" :style="media.type2 == 'image' ? `background: url('${media.url}');` : 'background-color: #f7f7f7;'">
                    <img v-if="media.type2 == 'image'" class="source" :src="media.url" alt="">
                    <video v-else-if="media.type2 == 'video'" class="source" :src="media.url" alt="" muted playsinline crossorigin="anonymous" :autoplay="autoplayVideo" loop preload="metadata" onloadedmetadata="this.muted = true"></video>
                </div>
    
                <SnippetNetwork v-if="notFile && snippet.link" :link="snippet.link"/>
                <div class="domaine-redirection" v-if="snippet.link"><i class="fa-solid fa-arrow-up-right"></i><p>{{ getHostname(snippet.link) }}</p></div>
              
             
            </div>
           
            

            <div class="post-title">
                <p v-html="titleTranslateMentionAndHastag || 'Titre'"></p>
            </div>
            <div class="post-text">
                <p v-html="textTranslateMentionAndHastag || 'Description'"></p>
            </div>
            <div class="post-page">
                <div class="img-pages">

                    <template v-for="(page,index) in visiblePages">
                        <Tooltip
                            :active="page.iconEdited"
                            :key="index"
                            :text="'Voir les modifications apportées'"
                            position="right"
                            :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`"
                            @click="() => onClickAvatar(page, index)"
                        >
                            <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                        </Tooltip>
                    </template>

                    <ContextMenu
                        v-if="pages.length > 4"
                        :options="hiddenPagesOptions"
                        id="contextMenuHiddenPagesPinterest"
                        v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                    >
                        <div class="page count">
                            +{{ pages.length - 3 }}
                        </div>
                    </ContextMenu>
                </div>
                <p class="name" v-if="featuredPage" @click="openPinterestPage(featuredPage)">{{ featuredPage.name }}</p>
            </div>
           
           
            
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip,
            ContextMenu
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            title : {
                type: String,
                default: 'Titre'
            },
            text : {
                type: String,
                default: 'Description'
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },

            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        methods: {
            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },

            openPinterestPage(page) {
                const url = `https://www.pinterest.com/${page.network_id}/`;
                window.open(url, '_blank');
            },

            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                page.iconEdited ? this.$emit('clickPage', page.id) : this.openPinterestPage(page)
            }
        },

        computed: {
            visiblePages() {
                return this.pages.slice(0, this.pages.length == 4 ? 4 : 3)
            },

            featuredPage() {
                return this.visiblePages.length ? this.visiblePages[this.visiblePages.length - 1] : null
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },

            autoplayVideo() {
                return localStorage.screenshot ? true : false
            },

            dateFormatPost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            notFile(){
                return !this.medias.length || !this.medias.filter(m => ['image','video'].includes(m.type2)).length
            },


            titleTranslateMentionAndHastag() {
                //return this.text
                return this.title.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.pinterest ? `<span class="mention">@${mention.mention.pinterest.id || mention.mention.pinterest.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.pinterest ? `<span class="mention">@${mention.mention.pinterest.id || mention.mention.pinterest.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
